import { generatePath } from 'react-router-dom';
import { Currency, formatBalance } from '@ui/src';
import ROUTES from '../../../routes';
import { AutoExchangeSettings } from '../types';

const targetStatuses = [
  {
    name: 'ARCH',
    value: 'ARCH',
  },
  {
    name: 'Booked',
    value: 'BOOKED',
  },
];

const formatAutoSettingsList = (
  list: AutoExchangeSettings[],
  currency: string,
  currencies?: Currency[],
): AutoExchangeSettings[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };
    const render: Record<string, React.JSX.Element> = {};

    const currentCurrency =
      result.maxAmountCurrencyId === result.exchangeCurrencyFromId
        ? currencies?.find(
            (currencyItem) => currencyItem.id === result.exchangeCurrencyFromId,
          )
        : currencies?.find(
            (currencyItem) => currencyItem.id === result.exchangeCurrencyToId,
          );

    result.url = generatePath(ROUTES.AUTO_SETTINGS_EDIT, {
      currency,
      settingId: result.id,
    });

    render.exchangeCurrencyFromId = (
      <div>
        {
          currencies?.find(
            (value) => value.id === result.exchangeCurrencyFromId,
          )?.name
        }
      </div>
    );
    render.targetStatus = (
      <div>
        {result?.targetStatus
          ? targetStatuses?.find(
              (status) => status.value === result?.targetStatus,
            )?.name
          : '-'}
      </div>
    );
    render.exchangeCurrencyToId = (
      <div>
        {
          currencies?.find((value) => value.id === result.exchangeCurrencyToId)
            ?.name
        }
      </div>
    );
    render.maxAmountPerOperation = (
      <div>
        {result.maxAmountPerOperation
          ? formatBalance(result.maxAmountPerOperation, currentCurrency)
          : '-'}
      </div>
    );
    render.minAmountPerOperation = (
      <div>
        {result.minAmountPerOperation
          ? formatBalance(result.minAmountPerOperation, currentCurrency)
          : '-'}
      </div>
    );
    render.maxAmountForPeriod = (
      <div>
        {result.maxAmountForPeriod
          ? formatBalance(result.maxAmountForPeriod, currentCurrency)
          : '-'}
      </div>
    );
    render.maxAmountPeriodInHours = (
      <div>
        {result.maxAmountPeriodInHours
          ? result.maxAmountPeriodInHours / 24
          : '-'}
      </div>
    );
    render.maxAmountCurrencyId = (
      <div>
        {result.maxAmountCurrencyId === result.exchangeCurrencyFromId
          ? 'Sell'
          : 'Buy'}
      </div>
    );
    render.active = <div>{result?.active ? 'Active' : 'Inactive'}</div>;

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAutoSettingsList;
